import { Component, inject, input, OnInit, output } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../../forms/ziro-form-abstract.directive';
import { Observable, of } from 'rxjs';
import { ZiroFormConfig } from '../../../../../forms/ziro-forms-models';
import { AssignedCallingDelegate } from '../../../../../shared/models/generated/ziroModels';
import {
  HtmlCheckboxType,
  HtmlSwitchSize,
  LabelTextSize,
  ZiroCheckboxConfig,
} from '../../../../../forms/fields/checkbox/ziro-checkbox.component';
import { ZiroIcons } from '../../../../../shared/models/ziro-icons.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ziro-calling-delegate-card-form',
  templateUrl: './calling-delegate-card-form.component.html',
  styleUrls: ['./calling-delegate-card-form.component.scss'],
  standalone: false,
})
export class CallingDelegateCardFormComponent
  extends ZiroFormAbstractDirective<AssignedCallingDelegate>
  implements OnInit
{
  private _translateService = inject(TranslateService);

  readonly delegateRemoved = output<string>();
  readonly photoBase64 = input<string>();
  readonly displayName = input<string>();
  readonly currentUser = input<string>();
  formConfig: ZiroFormConfig;
  ziroIcons = ZiroIcons;

  ngOnInit(): void {
    this._initFormConfig();
  }

  removeDelegateClicked(): void {
    this.delegateRemoved.emit(this.entity.id);
  }

  private _initFormConfig(): void {
    this.formConfig = {
      fields: {
        makeCallsEnabled: {
          dataAutomation: `make-calls-checkbox-${this.entity.id}`,
          label: 'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.make_calls.label',
          componentConfig: new ZiroCheckboxConfig({
            checkboxType: HtmlCheckboxType.LEFT_ALIGNED_CHECKBOX,
            size: HtmlSwitchSize.LG,
            textSize: LabelTextSize.LG,
          }),
          helpText: this._translateService.instant(
            'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.make_calls.helptext',
            {
              displayName: this.currentUser(),
            },
          ),
        },
        receiveCallsEnabled: {
          dataAutomation: `receive-calls-checkbox-${this.entity.id}`,
          label: 'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.receive_calls.label',
          componentConfig: new ZiroCheckboxConfig({
            checkboxType: HtmlCheckboxType.LEFT_ALIGNED_CHECKBOX,
            size: HtmlSwitchSize.LG,
            textSize: LabelTextSize.LG,
          }),
          helpText: this._translateService.instant(
            'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.receive_calls.helptext',
            {
              displayName: this.currentUser(),
            },
          ),
        },
        manageSettingsEnabled: {
          dataAutomation: `manage-calls-checkbox-${this.entity.id}`,
          label: 'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.manage_settings.label',
          componentConfig: new ZiroCheckboxConfig({
            checkboxType: HtmlCheckboxType.LEFT_ALIGNED_CHECKBOX,
            size: HtmlSwitchSize.LG,
            textSize: LabelTextSize.LG,
          }),
          helpText: this._translateService.instant(
            'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.manage_settings.helptext',
            {
              displayName: this.currentUser(),
            },
          ),
        },
      },
    };
  }

  protected submit(): Observable<null> {
    return of(null);
  }
}
